import { render, staticRenderFns } from "./icon_only_toggle.vue?vue&type=template&id=54290c1a"
import script from "./icon_only_toggle.vue?vue&type=script&lang=js"
export * from "./icon_only_toggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports